// Help Icons
import { MyCasesOutlined } from 'jl-design-system/components/icons/MyCasesOutlined';
import { OrdersOutlined } from 'jl-design-system/components/icons/OrdersOutlined';
import { ReturnsAndRefundsOutlined } from 'jl-design-system/components/icons/ReturnsAndRefundsOutlined';
import { DeliveryOutlined } from 'jl-design-system/components/icons/DeliveryOutlined';
import { HelpOutlined } from 'jl-design-system/components/icons/HelpOutlined';
import { ShopFinderOutlined } from 'jl-design-system/components/icons/ShopFinderOutlined';
import { TelephoneOutlined } from 'jl-design-system/components/icons/TelephoneOutlined';

// Money Icons
import { PartnerCardOutlined } from 'jl-design-system/components/icons/PartnerCardOutlined';
import { HomeOutlined } from 'jl-design-system/components/icons/HomeOutlined';
import { GiftCardOutlined } from 'jl-design-system/components/icons/GiftCardOutlined';
import { BillingOutlined } from 'jl-design-system/components/icons/BillingOutlined';

import CarIcon from '../../../assets/icons/car.svg';
import DogIcon from '../../../assets/icons/dog.svg';
import EuroIcon from '../../../assets/icons/euro.svg';
import PlaneIcon from '../../../assets/icons/plane.svg';

/**
 * Direct icon component lookup map
 * Maps menu labels directly to their icon components
 */
export const mobileNavIconMap = {
  Help: {
    'Customer services': MyCasesOutlined,
    'Track your order': OrdersOutlined,
    'Returns and refunds': ReturnsAndRefundsOutlined,
    'Delivery and collection': DeliveryOutlined,
    'Product support': HelpOutlined,
    'Shop finder': ShopFinderOutlined,
    'Contact us': TelephoneOutlined,
  },
  Money: {
    'Partnership Credit Card': PartnerCardOutlined,
    'Home Insurance': HomeOutlined,
    'Pet Insurance': DogIcon,
    'Car Insurance': CarIcon,
    'Travel Money': PlaneIcon,
    Investments: GiftCardOutlined,
    'International Payments': EuroIcon,
    Loans: BillingOutlined,
  },
};
